var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronSort = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Calque_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 5 11.36"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-ch-1{fill:#353f47;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "right-chevron"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  className: "cls-ch-1",
  d: "M2.79,11.24l2.09-2.26c.08-.08.13-.2.12-.32,0-.11-.04-.23-.12-.31l-.24-.26c-.07-.08-.18-.13-.29-.13-.11,0-.22.05-.29.13l-1.56,1.69-1.56-1.69c-.07-.08-.18-.13-.29-.13-.11,0-.22.05-.29.13l-.24.26c-.08.08-.12.19-.12.31,0,.12.04.23.12.31l2.09,2.27c.08.08.18.13.29.13.11,0,.22-.05.29-.13Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_Copy",
  className: "cls-ch-1",
  d: "M2.79.13l2.09,2.26c.16.18.16.45,0,.62l-.24.26c-.07.08-.18.13-.29.13-.11,0-.22-.05-.29-.13l-1.56-1.69-1.56,1.69c-.07.08-.18.13-.29.13-.11,0-.22-.05-.29-.13l-.24-.26c-.16-.18-.16-.45,0-.62L2.21.13C2.28.05,2.39,0,2.5,0c.11,0,.22.05.29.13Z"
})))));
export default SvgChevronSort;